import { IWorkerData } from '@th-types/worker.type';
import { ShiftPosition } from '@th-types/job.detail.type';

export enum WorkerModalTabsEnum {
  THIS_JOB = 'THIS_JOB',
  PROFILE_DETAILS = 'PROFILE_DETAILS',
  REVIEWS = 'REVIEWS',
  CALENDAR = 'CALENDAR',
  HISTORY = 'HISTORY',
  DOCUMENTS = 'DOCUMENTS',
  RESUME = 'RESUME',
  INTERNAL_NOTES = 'INTERNAL_NOTES',
}

export interface WorkerModalProps {
  jobAssignmentId?: number;
  workerId?: number; // Fallback for cases without job context
  jobId?: number; // Fallback for cases without job context
  onClose: () => void;
  show?: boolean;
  showJobDetails?: boolean;
  initialTab?: WorkerModalTabsEnum;
  worker?: IWorkerData; // Optional pre-loaded worker data
  zIndex?: number;
}

export interface WorkerModalTabConfig {
  key: WorkerModalTabsEnum;
  icon: React.ReactNode;
  label: string;
  component: React.ReactNode;
  disabled?: boolean;
}

// EditShiftForm types
export interface EditShiftFormData {
  date: Date | null;
  positionId: number;
  positionName: string;
  wage: number;
  payRatePeriod: 'hourly' | 'daily';
  startTime: Date | null;
  endTime: Date | null;
  paidBreak: 'yes' | 'no';
}

export interface EditShiftFormProps {
  formData: EditShiftFormData;
  onFormDataChange: (data: EditShiftFormData) => void;
  onSubmit: () => void;
  onCancel: () => void;
  isLoading: boolean;
  jobOptions?: {
    jobTitles?: Array<{
      id: number;
      name: string;
    }>;
  };
}

// OfferShiftForm types
export interface OfferShiftFormProps {
  selectedShifts: ShiftPosition[];
  worker: IWorkerData;
  offerNote: string;
  onOfferNoteChange: (note: string) => void;
  onSubmit: () => void;
  onCancel: () => void;
  isLoading: boolean;
  onEditShift?: (shift: ShiftPosition) => void;
  jobTimezone?: string;
}
